<!-- =========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
========================================================================================== -->

<template>
  <div class="relative">
    <vs-popup fullscreen title="Development Action" :active.sync="totdoPopup">
      <div class="w-full items-center">
      </div> </vs-popup>

    <vs-prompt
        :title="'Meeting Schedule for Coach ('+coachName+')'"
        accept-text="Request Meeting"
        :cancel-text="$t('Cancel')"
        @cancel="clearFields"
        @accept="sendInvite"
        @close="clearFields"
        :active.sync="activePrompt"
    >

      <form @submit.prevent>
        <div  class="flex justify-between my-2">
          <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl3") }}</label>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full flex flex-wrap">
              <vs-input
                  v-model.number="startH"
                  type="number"
                  color="warning"
                  :min="0"
                  :max="23"
                  @change="setDate()"
                  @keyup="setDate()"
                  placeholder="HH"
                  id="startHour"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full flex flex-wrap">
              <vs-input
                  v-model.number="startM"
                  type="number"
                  color="warning"
                  :min="0"
                  :max="59"
                  @change="setDate()"
                  @keyup="setDate()"
                  placeholder="MM"
                  id="startMinute"
              />
            </div>
          </div>
        </div>
        <div  class="flex justify-between my-2">
          <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl4") }}</label>
          <select
              class="selectType w-full dropdown timezone-select"
              v-model="timezone"
              @change="setDate()"
          >
            <optgroup label="Most Used Timezone">
              <option value="Asia/Kolkata" class="mt-4">Asia/Calcutta</option>
              <option value="Europe/Lisbon">Europe/Lisbon</option>
              <option value="GMT" class="mb-4">GMT</option>
            </optgroup>
            <optgroup label="All Timezones">
              <option
                  :key="index"
                  v-for="(allTimeZoneData, index) in allTimeZone"
                  :value="allTimeZoneData.value"
              >
                {{ allTimeZoneData.value }}
              </option>
            </optgroup>
          </select>
        </div>
        <div  class="flex justify-between my-2">
          <label class="mt-2 mr-1 align-middle label fix-label text-left">{{ $t("notes.lbl2") }}</label>
          <datePicker id="weekend-datetime-picker"
                      v-model="meetingDate"
                      name = "meetingDate"
                      class="text-primary bg-none w-full"
                      :value="meetingDate"
                      :format="DatePickerFormat"
                      :disabledDates="disabledDates"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"></datePicker>
        </div>
        
        <!-- 👇 UPDATED MEETING URL TOGGLE & CUSTOM INPUT 👇 -->
        <div class="flex flex-col my-2">
          <!-- If LOGGED IN USER has a URL in DB, show the toggle -->
          <div v-if="defaultMeetingUrl" class="flex justify-between items-center w-full mb-3">
            <label class="mt-2 mr-1 align-middle label fix-label text-left font-semibold">Use My Meeting Link?</label>
            <div class="flex items-center w-full">
              <vs-switch color="success" v-model="useDefaultMeetingUrl" class="mr-3">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
              <span v-if="useDefaultMeetingUrl" class="text-primary text-xs truncate max-w-[150px] italic">
                {{ defaultMeetingUrl }}
              </span>
            </div>
          </div>

          <!-- Custom URL (shows if DB has no URL OR user toggled it off) -->
          <div class="flex justify-between w-full" v-if="!defaultMeetingUrl || !useDefaultMeetingUrl">
            <label class="mt-2 mr-1 align-middle label fix-label text-left">Meeting Link (Optional)</label>
            <vs-input
              v-model="customMeetingUrl"
              class="w-full text-primary"
              placeholder="e.g., https://zoom.us/j/12345"
            />
          </div>
        </div>
        <!-- 👆 END UPDATED SECTION 👆 -->

        <div class="relative">
          <vs-textarea
              v-model="msg"
              name="msg"
              class="my-4 resize-0"
              placeholder="Meeting Purpose"
          >
          </vs-textarea>
        </div>
      </form>

    </vs-prompt>
    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <div class="flex justify-between items-center w-full flex-1">        
            <div class="flex items-center">
    <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />
    
    <!-- Safe Admin Check -->
    <span class="text-primary" v-if="activeUserInfo && activeUserInfo.userType === 'admin'" style="font-size:19px;">
        <b>Super Admin</b>
    </span>

    <!-- NEW Dropdown using vs-dropdown -->
<div v-else-if="globalOrgs && globalOrgs.length > 0" class="flex items-center ml-2">
  <vs-dropdown vs-trigger-click class="cursor-pointer">
    
    <!-- Trigger Button (What you see in the Navbar) -->
    <div class="flex items-center text-primary" style="font-size:19px;">
      <b>{{ activeOrgName }}</b>
      <feather-icon icon="ChevronDownIcon" class="ml-1 cursor-pointer" svgClasses="w-5 h-5 text-primary" />
    </div>

    <!-- The Menu Items -->
    <vs-dropdown-menu class="w-64 org-dropdown-menu">
  <vs-dropdown-item 
    v-for="org in globalOrgs" 
    :key="org.org_id"
    @click="changeOrg(org.org_id)"
  >
    <span class="font-semibold" :class="{'text-primary': org.org_id === globalActiveOrg}">
      {{ org.org_name }}
    </span>
  </vs-dropdown-item>
</vs-dropdown-menu>

  </vs-dropdown>
</div>

    <!-- Fallback -->
    <span v-else class="text-primary ml-2" style="font-size:19px;">
        <b>{{ companyName || 'Workspace' }}</b>
    </span>
</div>
            <vs-spacer />
            <div class="flex items-center">
                <TheCustomizer  v-if="userType==='coach'&&companyName==='GALA.GAMES'" ></TheCustomizer>
                <feather-icon class="mx-2" v-if="activeUserInfo.userType !=='admin' && activeUserInfo.userType !=='' && activeUserInfo.userType !=='coach'" icon="CalendarIcon" @click.stop="meetingRequest" title="Meeting Request" />
                <todo v-if="userType==='trainee'" :userId="this.$store.state.AppActiveUser.usersId" />
                <notes ref="notesComponent" v-if="userType==='trainee'" :commuId="this.$store.state.AppActiveUser.usersId" />
                <i18n class="mx-2"  />
                <profile-drop-down v-if="userType!==''" />
                <changeLog v-if="userType!==''" class="ml-2" />
            </div>
        </div>

      </vs-navbar>
    </div>
  </div>
</template>

<script>
  import Bookmarks            from './components/Bookmarks.vue'
  import I18n                 from './components/I18n.vue'
  import SearchBar            from './components/SearchBar.vue'
  import CartDropDown         from './components/CartDropDown.vue'
  import NotificationDropDown from './components/NotificationDropDown.vue'
  import ProfileDropDown      from './components/ProfileDropDown.vue'
  import Notes                from './components/Notes.vue'
  import TheCustomizer from "@/layouts/components/customizer/TheCustomizer.vue";
  import FeatherIcon from '../../../components/FeatherIcon.vue'
  import Todo from '../../../views/user/todo/Todo.vue'
  import ChangeLog from '../../../views//changelog.vue'
  import moment from "moment";
  import allTimeZone from "@/views/user/my-coach/allTimeZone";
  import Moment from 'vue-moment';
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import datePicker from "vuejs-datepicker"
  import {models} from "feathers-vuex";
  import i18n from "@/i18n/i18n";
  import axios from "axios";

  export default {
    name: 'the-navbar-vertical',
    props: {
      navbarColor: {
        type: String,
        default: '#fff'
      }
    },
    data(){
      return{
        companyName :null,
        totdoPopup:false,
        userType : JSON.parse(localStorage.getItem('userInfo')).userType,
        userTypeStatus:'',
        meetingDate: new Date(),
        DatePickerFormat: 'dd/MM/yyyy',
        disabledDates: {
          to: new Date(Date.now() - 8640000)
        },
        startH:
            moment().minutes() + 5 > 59
                ? (moment().hours() + 1) % 24
                : moment().hours() % 24,
        startM: (moment().minutes() + 5) % 60,
        schedule_time:'',
        timezone:'',
        msg : null,
        msgLength : 0,
        communicationId:'',
        userId: this.$store.state.AppActiveUser.usersId,
        allTimeZone,
        user_data: null,
        user_not_found: false,
        coachTraineeId:'',
        coachName:'',
        activePrompt:false,
        query:null,
        notes:[],
        profileBannerImage:'',
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.3
        },
        
        // NEW URL STATE VARIABLES
        defaultMeetingUrl: null,     // Stores YOUR (Logged in User) URL from DB
        useDefaultMeetingUrl: true,  // Toggle switch status
        customMeetingUrl: null,      // User manual input
      }
    },
    components: {
      Bookmarks,
      I18n,
      SearchBar,
      CartDropDown,
      NotificationDropDown,
      ProfileDropDown,
      TheCustomizer,
      Notes,
      Todo,
      ChangeLog,
      FeatherIcon,
      datePicker,
      moment,
      VuePerfectScrollbar
    },
    computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    globalOrgs() {
      return this.$store.state.userCoachOrgs || [];
    },
    globalActiveOrg() { 
      return this.$store.state.activeCoachOrgId; 
    },
    activeOrgName() {
      const active = this.globalOrgs.find(org => org.org_id === this.globalActiveOrg);
      return active ? active.org_name : (this.companyName || 'Workspace');
    }
  },
  
    methods: {
      todo(){
        this.totdoPopup=true;
      },
      showSidebar () {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      },
      formatDate(sentDate) {
        let date = new Date(sentDate)
        date = `${date.getFullYear()  }-${  date.getMonth() + 1  }-${  date.getDate()}`;
        return date;
      },
      meetingRequest(){
        this.activePrompt=true;
      },
      clearFields () {
        this.$nextTick(() => {
          this.user_email = "";
          this.customMeetingUrl = null; 
          this.useDefaultMeetingUrl = true;
        });
      },
      setDate() {
        if (this.meetingDate) {
          this.startD = moment.utc(this.meetingDate).format('YYYY-MM-DD');
          this.schedule_time = this.startD + ' ' + this.startH + ':' + this.startM + ':00';
        }
      },
     changeOrg(orgId) {
        this.$store.commit('SET_ACTIVE_COACH_ORG_ID', orgId);
        
        const selectedOrg = this.globalOrgs.find(org => org.org_id === orgId);

        if (selectedOrg) {
          let primaryColor = selectedOrg.primary_color;
          let secondaryColor = selectedOrg.secondary_color;

          if (primaryColor && primaryColor !== 'null' && primaryColor !== '') {
            if (!primaryColor.startsWith('#') && primaryColor.length <= 6) primaryColor = '#' + primaryColor;
            
            this.$vs.theme({ 'primary': primaryColor });
            window.localStorage.setItem('themeColor', primaryColor); 
          } else {
            this.$vs.theme({ 'primary': this.$store.state.themePrimaryColor }); 
            window.localStorage.removeItem('themeColor');
          }

          if (secondaryColor && secondaryColor !== 'null' && secondaryColor !== '') {
            if (!secondaryColor.startsWith('#') && secondaryColor.length <= 6) secondaryColor = '#' + secondaryColor;
            
            this.$vs.theme({ 'secondary': secondaryColor });
            window.localStorage.setItem('secondaryColor', secondaryColor); 
          } else {
            let fallback = primaryColor || this.$store.state.themeSecondaryColor;
            this.$vs.theme({ 'secondary': fallback });
            window.localStorage.removeItem('secondaryColor');
          }
        }
      },
      sendInvite () {
        if(this.meetingDate){
          this.meetingDate = this.meetingDate
          this.startD = moment.utc(this.meetingDate).format('YYYY-MM-DD');
          this.schedule_time =
              this.startD + ' ' + this.startH + ':' + this.startM + ':00';
        }else{
          this.schedule_time=null;
        }

        // 1. Calculate the final meeting URL
        let finalMeetingUrl = null;
        if (this.defaultMeetingUrl && this.useDefaultMeetingUrl) {
          finalMeetingUrl = this.defaultMeetingUrl;
        } else if (this.customMeetingUrl) {
          finalMeetingUrl = this.customMeetingUrl;
        }

        const note = {
          noteType: 4,
          authorId: this.userId,
          commuId: this.coachTraineeId,
          company: window.$cookies.get('companyName'),
          loginType: this.$store.state.AppActiveUser.userType,
          userRole: this.$store.state.AppActiveUser.userType,
          message: this.msg || 'Meeting Scheduled',
          meetingUrl: finalMeetingUrl, // Passes safely to our backend hook!
          createdAt: new Date(),
          updatedAt: new Date(),
          timezone: this.timezone,
          status: 0,
          meetingDate: this.schedule_time
        };

        if(this.msg){
          this.$store.dispatch("notesManagement/addNote", note)
          .then(res => {
            this.$vs.notify({
              title: i18n.t('notification.user.myCoach.addNote.success.a1'),
              text:  i18n.t('notification.user.myCoach.addNote.success.a2'),
              color: "primary"
            });

            if (this.$refs.notesComponent) {
              this.$refs.notesComponent.injectNewNote(res);
            }
            
            this.activePrompt = false;
            this.clearFields();
          })
          .catch(err => {
            this.$vs.notify({
              title: i18n.t('notification.user.myCoach.addNote.failed.a1'),
              text:  i18n.t('notification.user.myCoach.addNote.failed.a2'),
              color: "danger"
            });
          });
          this.msg = null;
        }
        else{
          this.$vs.notify({
            title: 'Warning',
            text:  'Meeting Purpose field is Required',
            color: "warning"
          });
        }
      },

    },
    async mounted() {
      if(window.$cookies.get('companyId')) {
        this.companyName = window.$cookies.get('companyName');
      } else {
        this.companyName = window.$cookies.get('companyName');
      }

      let email = null;
      if (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.email) {
        email = this.$store.state.AppActiveUser.email;
      }
      if (!email && localStorage.getItem('userInfo')) {
        try { email = JSON.parse(localStorage.getItem('userInfo')).email; } catch(e) {}
      }

      if (email) {
        try {
          const apiUrl = `https://parser.ai.getboarded.com/api/v2/user-frameworks/by-email/${email}`;
          const res = await axios.get(apiUrl);
          const orgs = res.data.data;
          
          this.$store.commit('SET_USER_COACH_ORGS', orgs);
          
          if (orgs.length > 0 && !this.globalActiveOrg) {
            this.$store.commit('SET_ACTIVE_COACH_ORG_ID', orgs[0].org_id);
          }
        } catch (err) {
          console.error("Failed to fetch coach orgs:", err);
        }
      }
    },
    created(){
      if(this.$store.state.AppActiveUser.userType !== 'admin'){
        if(window.localStorage['themeColor']== null || window.localStorage['secondaryColor']== null || window.localStorage['themeColor']=='undefined' || window.localStorage['secondaryColor']=='undefined'|| window.localStorage['themeColor']=='' || window.localStorage['secondaryColor']==''){
          this.$store.dispatch("userManagement/fetchUser", this.$store.state.AppActiveUser.usersId)
            .then(res => {
              let themeColor = res.company[0].themeColor;
              let secondColor = res.company[0].seconaryColor;
              if(themeColor == null || themeColor == 'undefined' || themeColor == ''){
                this.$vs.theme({'primary': this.$store.state.themePrimaryColor});
              }else{
                this.$vs.theme({'primary': themeColor});
              }
              if(secondColor == null || secondColor == 'undefined' || secondColor == ''){
                if(themeColor && themeColor != 'undefined'){
                  this.$vs.theme({'secondary': themeColor});
                }
                else{
                  this.$vs.theme({'secondary': this.$store.state.themeSecondaryColor});
                }
              }else{
                this.$vs.theme({'secondary': secondColor});
              }
            })
        }
        else{
          this.$vs.theme({'primary': window.localStorage['themeColor']});
          this.$vs.theme({'secondary': window.localStorage['secondaryColor']});
        }
      }else{
        this.$vs.theme({'primary': this.$store.state.themePrimaryColor});
        this.$vs.theme({'secondary': this.$store.state.themeSecondaryColor});
      }
      
      const usersId = this.$store.state.AppActiveUser.usersId;

      // 1. ALWAYS Fetch the Logged-In User's Profile to get THEIR Meeting URL
      this.$store.dispatch("userManagement/fetchUser", usersId)
        .then(myProfile => {
          this.defaultMeetingUrl = myProfile.meetingUrl || myProfile.meeting_url || null;
        })
        .catch(err => console.error("Could not fetch my profile", err));

      // 2. Fetch the assignment to get the Assigned Coach's Name (for the Title)
      this.$store
          .dispatch("traineeCoachAssignment/fetchAssignTraineeCoachQuery", {
            query: { traineeId: usersId }
          })
          .then(res => {
            this.coachTraineeId = res.data[0].coachId;
            if(res.data.length === 1){
              this.$store
                  .dispatch("userManagement/fetchUser", res.data[0].coachId)
                  .then(resCoach => {
                    this.user_data = resCoach;
                    this.coachName = resCoach.firstName; // Sets Title to "John"
                  })
                  .catch(err => {
                    this.user_not_found = true;
                  });
            }
            else{
              this.user_not_found = true;
            }
          })
          .catch(err => {
            console.log("trainee coach not found", err);
          });
          
      if(window.$cookies.get('companyId')) {
        this.companyName =window.$cookies.get('companyName');
      }
      else{
        this.companyName=window.$cookies.get('companyName');;
      }
    }
  }
</script>

<style lang="scss">
/* Make the Dropdown look like a seamless Header */
.org-dropdown-menu {
  z-index: 99999 !important;
}
</style>